import abstractFolderView from "./abstractFolderView.js";
import DocumentArchiveBreadCrumbsWidget from "./DocumentArchiveBreadCrumbsWidget.js";
import IconicSortingWidget from "./IconicSortingWidget.js";

/**
 * I am a concrete implementation of widget used to display the entries in a list of icons.
 */

/**
 * Todo: Add JSDoc comment
 */
function iconicFolderView(spec, my) {
	spec ||= {};
	my ||= {};

	const that = abstractFolderView(spec, my);

	my.buildBreadcrumbs = function () {
		const iconSorterWidget = new IconicSortingWidget({
			onChange: my.document.updateDocumentContent,
		});

		return new DocumentArchiveBreadCrumbsWidget({
			actions: [iconSorterWidget],
			isIconicView: my.document.isIconicView.bind(my.document),
		});
	};

	my.renderEntryWidgetsOn = function (widgets, html) {
		my.renderBackOn(html);

		widgets.forEach((entryWidget) => {
			renderEntryWidgetOn(entryWidget, html);
		});
	};

	my.renderBackToParentOn = function (html) {
		html.div({
			id: "backWidget",
			klass: "entryWidget iconicWidget",
		})
			.render((html) => {
				html.div({ klass: "big_icon" }).render(
					html
						.tag("i")
						.addClass("fa fa-arrow-circle-up fa-4x")
						.click(my.backToParent),
				);

				html.div({ klass: "name" }, (name) => {
					const anchor = name.a("..");
					anchor.click(my.backToParent);
				});
			})
			.dblclick(my.backToParent);
	};

	function renderEntryWidgetOn(entryWidget, html) {
		my.registerToEntryClick(entryWidget);
		entryWidget.renderIconicViewOn(html);
		my.registerToMouseEvents(entryWidget);
	}

	my.cssClass = function () {
		return "iconicView clearfix";
	};

	return that;
}

export default iconicFolderView;
